import type { PropertyPlansApiResponse } from '../types/plan.types';

function pickFirstNonEmpty(...values: Array<string | null | undefined>): string {
  for (const value of values) {
    const normalized = (value ?? '').trim();
    if (normalized) {
      return normalized;
    }
  }
  return '';
}

/** 現場略称 + optional (施工会社略称) for plan property header / PropertySection */
export function getPropertySectionDisplayName(
  property: PropertyPlansApiResponse['property'] | null | undefined
): string {
  if (!property) return '';
  const site = (property.nameAbbreviation ?? '').trim();
  const constructionAbbrev = pickFirstNonEmpty(
    property.constructionCompany?.nameAbbreviation,
    property.constructionCompanyName,
    property.constructionCompany?.name
  );
  if (constructionAbbrev) {
    return site ? `${site} (${constructionAbbrev})` : `(${constructionAbbrev})`;
  }
  return site;
}
